<template>
  <v-card class="mt-4 mx-auto" light>
    <v-sheet
      class="v-sheet--offset mx-auto"
      :color="attendance.color"
      elevation="12"
      max-width="calc(100% - 32px)"
    >
      <v-sparkline
        :labels="attendance.labels"
        :value="attendance.values"
        color="white"
        line-width="2"
        padding="16"
        stroke-linecap="round"
        smooth
      ></v-sparkline>
    </v-sheet>

    <v-card-text class="pt-0">
      <div
        v-if="attendance.period == 'This Week'"
        class="title font-weight-light mb-2"
      >{{ attendance.period }}</div>

      <div
        v-if="attendance.period == 'This Month'"
        class="title font-weight-light mb-2"
      >{{ attendance.period + ': ' + month }}</div>

      <div
        v-if="attendance.period == 'This Year'"
        class="title font-weight-light mb-2"
      >{{ attendance.period + ': ' + new Date().getFullYear() }}</div>

      <div class="subheading font-weight-light grey--text">Attendance</div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th v-if="attendance.period == 'This Week'" class="text-left">Day</th>
              <th v-if="attendance.period == 'This Month'" class="text-left">Week</th>
              <th v-if="attendance.period == 'This Year'" class="text-left">Month</th>

              <th v-if="attendance.events" class="text-left">Event</th>
              <th class="text-left">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in attendance.labels" :key="index">
              <td>{{ item }}</td>
              <td v-if="attendance.events">{{ attendance.events[index] }}</td>
              <td>{{ attendance.values[index] }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-divider class="my-2"></v-divider>
      <v-icon class="mr-2" small>mdi-timer</v-icon>
      <span class="caption grey--text font-weight-light">
        Highest attendance count:
        <strong>{{ Math.max(...attendance.values) }}</strong>
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AttendanceGraph",
  props: {
    attendance: {
      type: Object,
      required: true
    }
  },
  computed: {
    month: function() {
      Date.prototype.getMonthText = function() {
        var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        return months[this.getMonth()];
      };

      var now = new Date();
      var month = now.getMonthText();

      return month;
    }
  }
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>